import React, { useEffect, useState } from "react";
import { Box, Modal, Button, Link } from '@mui/material';
import { logo, error } from 'images';
import Grid from "@material-ui/core/Grid";
import { labels } from "_utils/labels";
const ModalPopup = ({ header, message1, message2, btnPrimaryText, btnSecondaryText, handlePrimaryClick, handleSecondaryClick, errors = false, showTextArea = false, onCommentChange, comment = "", isPrimaryDisable = false, hideBackdrop = true, children
}) => {
   const [open, setOpen] = useState(true);
   const [isDisablePrimaryButton, setIsDisablePrimaryButton] = useState(isPrimaryDisable);

   const handleClose = () => {
      onCommentChange?.("");
      setIsDisablePrimaryButton(true);
      setOpen(false);
      if (handleSecondaryClick) {
         handleSecondaryClick();
      }
   }

   useEffect(() => {
      setIsDisablePrimaryButton(isPrimaryDisable);
   }, [isPrimaryDisable]);
   return (
      <><React.Fragment>
         <Modal
            open={open}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
            className="displayblock"
            hideBackdrop={hideBackdrop} 
            slotProps={{
               backdrop: {
                  sx: {
                  backgroundColor: "rgba(0, 0, 0, 0.5)", // semi dark
                  backdropFilter: "blur(5px)",            // blur effect
                  },
               },
            }}>
            <Box className="  modalpopup">
               <Box className=" row modalpopupinner">
                  {!errors && <Grid item xs={12} className="p-0">
                     <Link href="#" variant="logo" className="wgllogo">
                        <img src={logo} alt="logo"></img>
                        {labels.eServicePortal}
                     </Link>
                     <h5 className="headercontent"><b>{header}</b></h5>
                     {message1 && <div className="modaldivopupcontent" style={{ wordBreak: 'break-word' }}> {message1}</div>}
                     {children}
                     {/* {message2 && <p className="modalpopupcontent"> {message2}</p>} */}
                     {message2 ? (
                        <p className="modalpopupcontent"> {message2}</p>
                     ) : showTextArea && (
                        <textarea
                           style={{
                              width: "100%",
                              minHeight: "80px",
                              marginTop: "1rem",
                              padding: "0.5rem",
                              fontSize: "1rem",
                              borderRadius: "4px",
                              border: "1px solid #ccc"
                           }}
                           placeholder="Add comment..."
                           value={comment}
                           onChange={(e) => {
                              const value = e.target.value;
                              onCommentChange?.(value);
                              setIsDisablePrimaryButton(value.length < 1);
                           }}
                        />
                     )}
                     {btnPrimaryText && <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className="Loginbutton mar-48"
                        onClick={handlePrimaryClick}
                        disabled={isDisablePrimaryButton}
                     >
                        {btnPrimaryText}
                     </Button>}
                     {btnSecondaryText &&
                        <Button
                           type="submit"
                           fullWidth
                           variant="contained"
                           color="secondary"
                           className="closebutton"
                           onClick={handleClose}
                        >
                           {btnSecondaryText}
                        </Button>}
                  </Grid>}
                  {errors && <Grid item xs={12} className="p-0">

                     <Link href="#" variant="logo" className="wgllogo">
                        <img src={logo} alt="logo"></img>
                        {labels.eServicePortal}
                     </Link>
                     <Grid container alignItems="center" spacing={2} className="p-0">
                        <Grid item xs={2}>
                           <img src={error} alt="logo"></img>
                        </Grid>
                        <Grid item xs={10}>
                           <h4 className="headercontent" style={{ margin: 0 }} ><b>{header}</b></h4>
                           {message1 && <p className="modalpopupcontent" style={{ margin: 0 }}> {message1}</p>}
                           {message2 && <p className="modalpopupcontent" style={{ margin: 0 }}> {message2}</p>}
                        </Grid>
                     </Grid>
                     {btnPrimaryText && <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className="Loginbutton mar-48"
                        onClick={handlePrimaryClick}
                     >
                        {btnPrimaryText}
                     </Button>}
                     {btnSecondaryText &&
                        <Button
                           type="submit"
                           fullWidth
                           variant="contained"
                           color="secondary"
                           className="closebutton"
                           onClick={handleClose}
                        >
                           {btnSecondaryText}
                        </Button>}
                  </Grid>}
               </Box>
            </Box>
         </Modal>
      </React.Fragment>
      </>
   );

};

export default ModalPopup;